import { BindingPath } from "../../CoreTypes";
import { Guid } from "../../../Types/Guid";
import { ServerErrorLog } from "../../../../../../Common/CandyApiClient/Types/ErrorLog/ServerErrorLog";

export enum ItemErrorMessageType {
    external = "external",
    navLink = "navLink",
    text = "text",
}

export interface NavLinkErrorMessage {
    type: ItemErrorMessageType.navLink;
    text: string;
    highlanderUrl: string;
    bindingPaths: BindingPath[];
}

export type ItemErrorMessage =
    | {
          type: ItemErrorMessageType.external;
          text: string;
          url?: string;
      }
    | NavLinkErrorMessage
    | {
          type: ItemErrorMessageType.text;
          text: string;
          hideLinks?: boolean;
          url?: string;
      };

export interface ErrorLogItem {
    id: Guid;
    description: ItemErrorMessage[];
    highlanderPath: null | undefined | string;
    bindingPaths?: undefined | BindingPath[];
    source: string[];
    tags: string[];
    highlanderUsedArguments: string[] | undefined;
    usedArgumentBindingPaths: undefined | BindingPath[];
    touched: boolean;
    justification?: string;
}

export interface ErrorLogItems {
    [key: string]: ErrorLogItem;
}

export interface ErrorLogGroupInfo {
    groupName: string | null;
    errorIds: string[];
    warningIds: string[];
    successIds: string[];
    groupAttachmentId?: string;
    tid?: string;
}

export interface ErrorLog {
    errorsTotalCount: number;
    warningsTotalCount: number;
    successesTotalCount: number;
    errorLogName?: null | string;
    propsName?: null | string;
    canSend?: boolean;
    hasErrors?: boolean;
    marketplaceContext?: MarketplaceContext;
    errorGroupInfos: ErrorLogGroupInfo[];
    errors?: ErrorLogItems;
    warnings?: ErrorLogItems;
    successes?: ErrorLogItems;
    interdocumentCheckerResult?: InterdocumentCheckerResult | null;
    isChecking?: boolean;
    requestFailed?: true;
    errorLogWasRequested?: true;
    counterEnabled?: boolean;
}

export interface IErrorLogTaskInfo {
    errorMessage?: string;
    isFinished: boolean;
    needRestart?: boolean;
    taskId: Guid;
    progress: number;
    result: IErrorLogTaskResult;
}

export enum InterdocumentCheckStatus {
    Fail = "fail",
    Success = "success",
}

export enum InterdocumentCheckType {
    // deprecated - переехали в issues
    Error = "error",
    // deprecated - переехали в issues
    Warning = "warning",

    Fine = "fine",
    NotFound = "notfound",
    Issues = "issues",
}

export enum InterdocumentIssueSeverity {
    Warning = "warning",
    Error = "error",
}

export interface InterdocumentIssue {
    id: string;
    description: string;
    severity: InterdocumentIssueSeverity;
}

export interface CheckedReport {
    id: string;
    url: string;
    caption: string;
}

export interface DiscrepancyInfo {
    discrepanciesCount: number;
    issues: InterdocumentIssue[];
}

export interface InterdocumentCheck {
    type: InterdocumentCheckType;
    title: string;
    userDescription?: string;
    issues?: InterdocumentIssue[];
    checkedReports?: CheckedReport[];
    discrepancyInfo: DiscrepancyInfo | null;
}

export interface InterdocumentCheckerResult {
    status: InterdocumentCheckStatus;
    failReason?: string;
    checks?: InterdocumentCheck[];
}

export interface MarketplaceContext {
    customScenarios?: {
        bushTestDrive?: null | {
            urlOsno: string;
            urlUsn: string;
        };
    };
}

export interface IErrorLogTaskResult {
    errorLogName?: null | string;
    propsName?: null | string;
    hasErrors: boolean;
    canSend: boolean;
    marketplaceContext?: MarketplaceContext;
    mainReportCheckLog: ServerErrorLog;
    mainReportCrossCheckLog: ServerErrorLog;
    warrantCheckLog: ServerErrorLog | null;
    digitalWarrantCheckLog: ServerErrorLog | null;
    interdocumentsCheckLog: InterdocumentCheckerResult | null;
    attachmentsCheckLogsWithIds: { [attachmentId: string]: ServerErrorLog };
}

export function isHeavyErrorLog(errorLog: ServerErrorLog | IErrorLogTaskResult): errorLog is IErrorLogTaskResult {
    return errorLog.hasOwnProperty("mainReportCheckLog");
}
